(function () {
    'use strict';

    angular.module('app')
        .factory('Configuracion', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "configuracion";
        return ResourceHelper.getResource(entidad, {}, {});
    }

})();
